import { AiOutlineEdit } from "react-icons/ai";
type Props = { data: any };

const TeamMemberPermissions = ({ data }: Props) => {
  return (
    <div className="bg-white p-4 rounded-lg flex items-center justify-between">
      <h3 className="text-color-primary text-xl font-semibold">
        Member permissions
      </h3>
      <div className="flex items-center justify-between gap-2">
        <div className="bg-[#EEF0FF] py-3 px-4 rounded-lg">Medium</div>
        <AiOutlineEdit className="text-[#9999A7] flex items-center text-lg justify-center text-center " />
      </div>
    </div>
  );
};

export default TeamMemberPermissions;
